export const middleEasternCodes = [
  'BH',
  'EG',
  'IR',
  'IQ',
  'IL',
  'JO',
  'KW',
  'LB',
  'OM',
  'PS',
  'QA',
  'SA',
  'SY',
  'TR',
  'AE',
  'YE',
]

export const middleEasternNationalities = [
  'Bahraini',
  'Egyptian',
  'Iranian, Persian',
  'Iraqi',
  'Israeli',
  'Jordanian',
  'Kuwaiti',
  'Lebanese',
  'Omani',
  'Palestinian',
  'Qatari',
  'Saudi, Saudi Arabian',
  'Syrian',
  'Turkish',
  'Emirati, Emirian, Emiri',
  'Yemeni',
]
